<template>
    <div :ref="mapId" class="map bucketMap"/>
</template>

<script>
import gmaps from "@/gmaps.js"
import Helpers from "@/helpers.js"
import { mapState } from "vuex"

export default {
  name: "bucket-map",
  props: {
    gmapHelpers: {
      type: Object,
      default: function() {
        return gmaps
      }
    },
    mapField: { type: String },
    searchTerm: { type: String, default: "" },
    searchField: { type: String, defaylt: "" }
  },
  computed: {
    ...mapState({
      bucketId: state => state.buckets.current.bucket.id,
      cases: state => state.buckets.current.cases ? state.buckets.current.cases : [],
      mapPoints: state => state.buckets.current.bucket.mapPoints ? state.buckets.current.bucket.mapPoints : [],
      currentUser: state => state.currentUser
    }),
    apiKey() {
      try {
        const attrs = JSON.parse(this.currentUser.account.lifeCycleCallbacks)
        const apiKey = attrs.params.google.places.apiKey
        return apiKey
      } catch (error) {
        console.log("API Key not found, using default")
        return "AIzaSyClXhrOdY3Pw9lLHAMojsVloOrowThgGek"
      } 
    },    
  },
  data: () => {
    return {
      mapId: "bucket-map",
      markerImageUrl: "https://storage.googleapis.com/ea-public/assets/cb-map-marker.png",
      mapStyleUrl: "https://storage.googleapis.com/ea-public/assets/m1.png",
      map: null,
      defaultZoom: 2,
      markers: []
    }
  },
  async mounted() {
    if (!this.map) {
      await this.init()
    }
    if (this.mapField !== "") {
      await this.handleUpdatedMapField()
    }
  },
  watch: {
    async mapField() {
      await this.handleUpdatedMapField()
    },
    async searchTerm() {
      await this.handleUpdatedMapField()
    }
  },
  methods: {
    async init() {
      await this.$store.dispatch('getOrderedBucketMapPoints', {
        bucketId: this.bucketId,
        searchTerm: this.searchTerm,
        searchableBy: this.searchField,
        mapField: this.mapField
      })
      try {
        await this.gmapHelpers.init(this.apiKey)
        this.map = this.gmapHelpers.getMap(this.$refs[this.mapId])
        if (this.mapPoints) {
          this.markMapPoints()
        }
        await this.updateLocation()
      } catch (error) {
        console.error(error)
      }
    },
    async handleUpdatedMapField() {
      await this.$store.dispatch('getOrderedBucketMapPoints', {
        bucketId: this.bucketId,
        searchTerm: this.searchTerm,
        searchableBy: this.searchField,
        mapField: Helpers.formatSnakeCase(this.mapField)
      })
      if (this.mapPoints) {
        this.markMapPoints()
      }
      await this.updateLocation()
    },
    clearMapPoints() {
      for (const marker of this.markers) {
        marker.setMap(null)
      }
      this.markers = []
    },
    markMapPoints() {
      this.clearMapPoints()
      for (const mapPoint of this.mapPoints) {
        const position = this.gmapHelpers.getLatLng(mapPoint.latitude, mapPoint.longitude)
        const marker = this.gmapHelpers.getMarker({ map: this.map, position, icon: this.markerImageUrl })
        const infoWindow = this.gmapHelpers.getInfoWindow(this.generateContentString(mapPoint))
        this.markers.push(marker)
        marker.addListener(`click`, () => { infoWindow.open(this.map, marker) })
      }
    },
    generateContentString(mapPoint) {
      const caseIndex = this.cases.map((cas) => cas.id).indexOf("" + mapPoint.id)
      let currentState = ""
      let caseTypeName = ""
      let caseRoute = `#/case/${mapPoint.id}/details`
      let title = mapPoint.title
      if (caseIndex > -1) {
        const currentCase = this.cases[caseIndex]
        const caseType = Helpers.getCaseTypeById(this.$store.state, currentCase.properties.case_type_id)
        caseTypeName = caseType.displayName
        title = currentCase.title.value
        currentState = currentCase.currentState
        caseRoute = `#/case/${currentCase.id}/details`
      }
      return `<a href="${caseRoute}" style="text-decoration: none;">
                <div class="v-flex xs12">
                  <h3 class="ma-1 icon-bold-link primary--text text-truncate">${title}</h3>
                </div>
                <div class="v-flex xs12">
                  <h4 class="ma-1 text-truncate">
                    <span class="primary--text body-1 opacity-54">
                      ${caseTypeName} -
                    </span>
                    <span class="primary-text body-1 opacity-54 font-weight-bold">
                      ${currentState}
                    </span>
                  </h4>
                </div>
              </a>`
    },
    async updateLocation() {
      if (this.mapPoints && this.mapPoints.length > 0) {
        const bounds = this.gmapHelpers.getLatLngBounds()
        for (const point of this.mapPoints) {
          const position = this.gmapHelpers.getLatLng(point.latitude, point.longitude)
          bounds.extend(position)
        }
        this.map.fitBounds(bounds)
      } else {
        const location = await this.gmapHelpers.geocode({ address: "europe" })
        this.map.setCenter(location.geometry.location)
        this.map.setZoom(this.defaultZoom)
      }
    }
  }
}
</script>

<style>
.map {
  width: 100%;
  height: 500px;
}

.bucketMap {
  -webkit-border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.map-popup {
  background: white;
  position: relative;
  padding: 15px 30px 15px 70px;
}

.coloured-bg {
  width: 40px !important;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background: #7eaab5; /* Old browsers */
  background: -moz-linear-gradient(
    top,
    #7eaab5 0%,
    #468595 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #7eaab5 0%,
    #468595 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #7eaab5 0%,
    #468595 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

/*style the box*/
.gm-style .gm-style-iw {
  top: 0 !important;
  left: 0 !important;
  width: 250px !important;
  padding: 0px;
  display: block !important;
  border-radius: 3px;
}

.gm-style-iw-d {
  overflow: auto !important;
}

/*style the p tag*/
.gm-style .gm-style-iw #google-popup p {
  padding: 10px;
}
</style>
